import React from 'react';

import OfferIcon from '@/assets/icons/offer-icon.svg';
import EventIcon from '@/assets/icons/events.svg';

import { TenantCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import { CardLogo } from './card-logo';
import { FavouriteButton } from '../ui/favourite-button/favourite-button';
import { ILibraryTenantAttributeFilters } from '@/lib/fragments/libraryTenantAttributeFilters';
import {
  useTenantConfig,
  useGetLibraryConstantsDictionaryData,
} from '@/providers/ConfigProvider';
import Link from 'next/link';
import { isMemberDayTag } from '../constants/memberdayTagName';

interface CardTenantProps {
  card: TenantCard;
  cardIndex: number;
  attributeFilters?: ILibraryTenantAttributeFilters;
}
export const CardTenant = ({
  card,
  cardIndex,
  attributeFilters,
}: CardTenantProps) => {
  const config = useTenantConfig();
  const dictionary = useGetLibraryConstantsDictionaryData();
  const isLivliFamily = config?.NEXT_PUBLIC_IS_MP_LIVLI_FAMILY === 'true';
  return (
    <div className="relative">
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group flex cursor-pointer flex-col rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light h-full`}
      >
        {card?.image?.url ? (
          <div className="relative aspect-[1.5/1] overflow-hidden rounded-t-xl">
            <ImageWrapper
              url={card?.image?.url}
              alt={card?.image?.description ?? 'alt text not found'}
              fill
              width={
                card?.image?.width ? parseInt(card.image.width) : undefined
              }
              height={
                card?.image?.height ? parseInt(card.image.height) : undefined
              }
              className="object-cover"
              imgClassName="object-cover"
            />
            <CardLogo
              card={card}
              className="!absolute top-5 left-5 w-16 h-16 bg-brand-white rounded-[12px] flex items-center justify-center"
            />
          </div>
        ) : (
          <div className="aspect-1.5/1 flex-grow"></div>
        )}
        <div className="flex min-h-40 flex-1 flex-col flex-wrap rounded-b-xl bg-background-primary-light px-6 py-5 transition-all duration-200 lg:group-hover:bg-background-secondary">
          <div className="text-sm mt-1 font-title font-bold">{card?.name}</div>
          <div className="text-bodys">
            {card?.categories
              ?.map((category) => category.name)
              .toString()
              .replaceAll(',', ', ')}
          </div>
          {isLivliFamily &&
            card?.offerCampaignNames?.some((t) => isMemberDayTag(t)) && (
              <div className="flex flex-wrap gap-1 my-4 items-center">
                <span
                  className={`inline-flex flex-shrink-0 items-center rounded-[4px] border-2 bg-background-primary-light px-2 text-bodyxs font-bold text-text-default border-brand-yellow-2`}
                >
                  {dictionary?.memberDayText}
                </span>
              </div>
            )}
          <div className="mt-auto flex w-full items-center">
            {card?.giftCard && attributeFilters?.giftCardIcon?.url && (
              <ImageWrapper
                url={attributeFilters.giftCardIcon.url}
                alt={attributeFilters?.giftCardIcon?.description ?? ''}
                imgClassName="mr-2 w-10.5"
                width={
                  attributeFilters.giftCardIcon.width
                    ? parseInt(attributeFilters.giftCardIcon.width)
                    : undefined
                }
                height={
                  attributeFilters.giftCardIcon.height
                    ? parseInt(attributeFilters.giftCardIcon.height)
                    : undefined
                }
              />
            )}
            {card?.loyaltyCard && attributeFilters?.loyaltyCardIcon?.url && (
              <ImageWrapper
                url={attributeFilters.loyaltyCardIcon.url}
                alt={attributeFilters?.loyaltyCardIcon?.description ?? ''}
                imgClassName="mr-2 w-10.5"
                width={
                  attributeFilters.loyaltyCardIcon.width
                    ? parseInt(attributeFilters.loyaltyCardIcon.width)
                    : undefined
                }
                height={
                  attributeFilters.loyaltyCardIcon.height
                    ? parseInt(attributeFilters.loyaltyCardIcon.height)
                    : undefined
                }
              />
            )}
            {card?.eventPage && (
              <div className="w-10.5">
                <EventIcon />
              </div>
            )}
            {card?.offerPage && (
              <div className="w-10.5">
                <OfferIcon />
              </div>
            )}
          </div>
        </div>
      </Link>
      <FavouriteButton
        id={card.id}
        type={card.favouriteType}
        className="absolute top-5 right-5 z-1 h-12 w-12"
        iconclass="h-6 w-6"
        name={card?.name}
      />
    </div>
  );
};
